const tunings = [{
  desc: '',
  name: 'Standard',
  notes: ['E', 'A', 'D', 'G', 'B', 'E'],
}, {
  desc: '',
  name: 'Drop D',
  notes: ['D', 'A', 'D', 'G', 'B', 'E'],
}, {
  desc: '',
  name: 'Double Drop D',
  notes: ['D', 'A', 'D', 'G', 'B', 'D'],
}, {
  desc: '',
  name: 'DADGAD',
  notes: ['D', 'A', 'D', 'G', 'A', 'D'],
}, {
  desc: '',
  name: 'CGDGBD - Open G/C Add4',
  notes: ['C', 'G', 'D', 'G', 'B', 'D'],
}, {
  desc: '',
  name: 'DGDBGD - Open G',
  notes: ['D', 'G', 'D', 'G', 'B', 'D'],
}, {
  desc: 'Tiny Moving Parts tuning',
  name: 'DAEAC#E - Open A add4',
  notes: ['D', 'A', 'E', 'A', 'C#', 'E'],
}, {
  desc: 'American Football tuning',
  name: 'FACGCE - F Maj9 Tuning',
  notes: ['F', 'A', 'C', 'G', 'C', 'E'],
}, {
  desc: 'Slipknot tuning',
  name: 'BF#BEG#C# - Drop B',
  notes: ['B', 'F#', 'B', 'E', 'G#', 'C#'],
}, {
  desc: '',
  name: '7 strings Standard',
  notes: ['B', 'E', 'A', 'D', 'G', 'B', 'E'],
}, {
  desc: '',
  name: 'Bass Standard',
  notes: ['E', 'A', 'D', 'G'],
}].map(function (x) {
  x.notes.reverse()
  return x
})

export default tunings;



// WEBPACK FOOTER //
// ./src/constants/tunings.js